import api from "@/lib/axios";

export interface Mentor {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
  updatedAt?: string;
  bio?: string;
  calendarLink?: string;
  auth0Id?: string;
  referralCode?: string;
  stripeRecipientAccountId?: string | null;
  payoutsActivated?: boolean | null;
  isActive?: boolean;
}

export interface SpaceGroup {
  id: number;
  name: string;
}

export enum MentorsKeys {
  CREATE_MENTOR = "create-mentor",
  GET_MENTORS = "get-mentors",
  GET_MENTOR = "get-mentor",
  GET_SPACE_GROUPS = "mentors-get-space-groups",
  GET_ME = "mentors-me",
  GET_REFERRAL_CODE = "mentors-referral-code",
}

export const createMentor = async (payload: Partial<Mentor>) => {
  const response = await api.post("/mentors", payload);
  return response.data as Mentor;
};

export const getMentors = async () => {
  const response = await api.get("/mentors");
  return response.data as Mentor[];
};

export const getMentor = async (id: string) => {
  const response = await api.get(`/mentors/${id}`);
  return response.data as Mentor;
};

export const updateMentor = async (
  id: string,
  updatedMentor: Partial<Mentor>,
) => {
  const response = await api.patch(`/mentors/${id}`, updatedMentor);
  return response.data as Mentor;
};

export const getCircleSpaceGroups = async () => {
  const response = await api.get("/circle/space-groups");
  return response.data as SpaceGroup[];
};

export const getOwnMentor = async () => {
  const response = await api.get("/mentors/me");
  return response.data as Mentor;
};

export const getMentorReferralCode = async (): Promise<{
  referralCode: string;
}> => {
  const response = await api.get("/mentors/referral-code");
  return response.data;
};

export interface UpdateMentorSettingsPayload {
  bio?: string;
  calendarLink?: string;
}

export const updateOwnMentorSettings = async (
  payload: UpdateMentorSettingsPayload,
) => {
  const response = await api.patch("/mentors/settings", payload);
  return response.data;
};
